import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from './xv-hotel';
import { AppMenuViewModel }                      from '../../app/xv-menu';
import { MLText, mlBroker }                      from '../../services/MLText';

export class SignInViewModel {
    ShowSelectLang:  (myEvent: any) => void;
    GotToWelcome:    ()             => void;

    mlText:          MLText;
    app:             mlBroker;
    ml:              mlBroker;
    Hotel:           dmHotel;
    Menu:            AppMenuViewModel;
    LangID:          number;
    LangCode:        string;

    UserName:        string;
    Credentials:     string;

    AccountNotFound: boolean;
    BadCredentials:  boolean;
    HasLoginError:   boolean;
    LoginError:      string;

    constructor(
         pMLText:         MLText
        ,pHotel:          dmHotel
        ,pMenu:           AppMenuViewModel
        ,pGoToWelcome:    ()             => void
        ,pShowSelectLang: (myEvent: any) => void
    ) {
        this.mlText          = pMLText;
        this.LangID          = this.mlText.GetLangID();
        this.app             = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml              = this.mlText.GetBroker(
            'BookingEngineSignIn'
        );

        this.Hotel           = pHotel;
        this.Menu            = pMenu;
        this.GotToWelcome    = pGoToWelcome;
        this.ShowSelectLang  = pShowSelectLang;

        this.UserName        = '';

        this.Credentials     = '';
        this.AccountNotFound = false;
        this.BadCredentials  = false;
        this.HasLoginError   = false;
        this.LoginError      = '';

        this.LangCode        = this.mlText.GetLangCode();
    }

    public ChangeLanguage(pLangID: number): void {
        this.LangID = pLangID;

        this.mlText.ChangeLanguage(pLangID, () => {
            this.LangCode = this.mlText.GetLangCode();

            this.Menu.initialise();
        });
    }

    public HotelNeedsDiscountSettingsAction(pPredicate: (
        pNeedsAction: boolean
    ) => void): void {
        let actionParams = RQParam.OtaHotelNeedsDiscountSettingsActionParams();

        actionParams.HotelID = this.Hotel.HotelID;

        RQService.Ota.HotelNeedsDiscountSettingsAction(actionParams).then((result) => {
            let response = result as any;

            if (response.HasErrorOrException) { pPredicate(false); return; }

            let actionList = response.RQueryResult;

            let action = RQService.Ota.PopulateHotelNeedsDiscountSettingsActionRow(
                actionList[0]
            );

            if (action.HotelNeedsDiscountSettingsAction == 1) {
                pPredicate(true);
            } else {
                pPredicate(false);
            }
        });
    }

    public SignIn(): void {
        if (this.Hotel.InSignInOut) { return; }

        this.Hotel.SignIn(
             this.UserName
            ,this.Credentials
            ,(pAuthResult) => {
                this.Credentials = '';

                if (pAuthResult.IsAuthenticated) {
                    this.AccountNotFound = false;
                    this.BadCredentials  = false;
                    this.HasLoginError   = false;
                    this.LoginError      = '';

                    this.GotToWelcome();
                } else {
                    this.HasLoginError   = true;
                    this.AccountNotFound = pAuthResult.AccountNotFound;
                    this.BadCredentials  = pAuthResult.BadCredentials;
                    this.LoginError
                        = (pAuthResult.BadCredentials)
                        ? this.app.Text('IncorrectPassword' ,'Incorrect Password')
                        : this.app.Text('UnknownUserName'   ,'Unknown User Name')
                }

                return;
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/sign-in/xv-sign-in.ts